import { BlockedRecordBlockedType } from '@exam-center/graphql';

export const STAFF_BLOCKED_TYPES = [
  BlockedRecordBlockedType.Staff,
  BlockedRecordBlockedType.ExamCenterManager,
  BlockedRecordBlockedType.Instructor,
  BlockedRecordBlockedType.Vendor,
  BlockedRecordBlockedType.MysteryAudit,
  BlockedRecordBlockedType.Proctor_1,
  BlockedRecordBlockedType.Proctor_2,
  BlockedRecordBlockedType.Proctor_3,
] as const;
